import { render, staticRenderFns } from "./TrangDanhSachTinhThanhPho.vue?vue&type=template&id=da42b9e4&"
import script from "./TrangDanhSachTinhThanhPho.vue?vue&type=script&lang=js&"
export * from "./TrangDanhSachTinhThanhPho.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports